<template>
  <b-modal @hide="modalClose" ref="companyModal" :title="$t('会社情報登録')" size="xl" hide-footer>
    <company
    :modal="true"
    :company="company"
    @modal-close="modalClose()"
    @registered="registered()"
    ref="company"
    ></company>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import company from '../company/index'
export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    company,
  },
  data() {
    return {
      create: {
        load: false,
        registration: false,
        error: '',
      },
    }
  },
  methods: {
    // モーダルの開く時の処理
    modalOpen() {
      this.$refs.companyModal.show()
    },
    // モーダル閉じる処理
    modalClose() {
      this.$refs.company.valueInit()
      this.$emit('modal-close')
      this.$refs.companyModal.hide()
    },
    // 登録が完了した時の処理
    registered() {
      this.$refs.company.valueInit()
      this.$emit('registered')
      this.$refs.companyModal.hide()
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
